import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import del from "../images/del.svg";
import refresh from "../images/refresh.svg";

function RoundedChevron({ direction }) {
  const path =
    direction === "left"
      ? "M14.71 6.71c-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z"
      : "M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z";

  return (
    <span className="tip-nav-chevron" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path d={path} fill="currentColor" />
      </svg>
    </span>
  );
}

function TipBox(props) {
  const { t } = useTranslation();
  const openH = -400;
  const closeH = -120;
  const mobileViewport = window.matchMedia("(max-width: 1023.98px)").matches;
  const [state, setState] = useState(() => {
    return mobileViewport || localStorage.getItem("wasClosed") ? closeH : openH;
  });
  const [dragMargin, setDragMargin] = useState(null);
  const dragRef = useRef(null);
  const suppressClickRef = useRef(false);
  const activeMargin = dragMargin === null ? state : dragMargin;
  const dragProgress = Math.max(
    0,
    Math.min(1, (closeH - activeMargin) / (closeH - openH))
  );
  const openPanelHeight = Math.min(window.innerHeight * 0.52, 430);
  const dragPanelHeight = 76 + (openPanelHeight - 76) * dragProgress;
  const setSheetState = (nextState) => {
    setState(nextState);
    if (nextState === closeH) {
      localStorage.setItem("wasClosed", true);
    } else {
      localStorage.removeItem("wasClosed");
    }
  };
  const toggleSheet = () => {
    setSheetState(state === closeH ? openH : closeH);
  };
  const startSheetDrag = (clientY, pointerId, inputType) => {
    dragRef.current = {
      pointerId,
      inputType,
      startY: clientY,
      startMargin: state,
      moved: false,
    };
    suppressClickRef.current = false;
  };
  const handleSheetPointerDown = (event) => {
    startSheetDrag(event.clientY, event.pointerId, "pointer");
    event.currentTarget.setPointerCapture?.(event.pointerId);
  };
  const handleSheetPointerMove = (event) => {
    const drag = dragRef.current;
    if (
      !drag ||
      drag.inputType !== "pointer" ||
      drag.pointerId !== event.pointerId
    ) {
      return;
    }

    const deltaY = event.clientY - drag.startY;
    if (Math.abs(deltaY) > 4) drag.moved = true;

    const nextMargin = Math.max(
      openH,
      Math.min(closeH, drag.startMargin + deltaY)
    );
    setDragMargin(nextMargin);
    event.preventDefault();
  };
  const finishSheetDrag = (event) => {
    const drag = dragRef.current;
    if (
      !drag ||
      drag.inputType !== "pointer" ||
      drag.pointerId !== event.pointerId
    ) {
      return;
    }

    const deltaY = event.clientY - drag.startY;
    finishSheetDragAt(deltaY);

    if (event.currentTarget.hasPointerCapture?.(event.pointerId)) {
      event.currentTarget.releasePointerCapture(event.pointerId);
    }
  };
  const finishSheetDragAt = (deltaY) => {
    const drag = dragRef.current;
    if (!drag) return;

    const currentMargin = Math.max(
      openH,
      Math.min(closeH, drag.startMargin + deltaY)
    );

    if (drag.moved) {
      const midpoint = (openH + closeH) / 2;
      const nextState =
        deltaY <= -32
          ? openH
          : deltaY >= 32
            ? closeH
            : currentMargin <= midpoint
              ? openH
              : closeH;

      suppressClickRef.current = true;
      setSheetState(nextState);
    }

    setDragMargin(null);
    dragRef.current = null;
  };
  const findTouch = (touches, identifier) => {
    return Array.from(touches || []).find(
      (touch) => touch.identifier === identifier
    );
  };
  const handleSheetTouchStart = (event) => {
    const touch = event.touches[0];
    if (!touch) return;
    startSheetDrag(touch.clientY, touch.identifier, "touch");
  };
  const handleSheetTouchMove = (event) => {
    const drag = dragRef.current;
    if (!drag || drag.inputType !== "touch") return;

    const touch = findTouch(event.touches, drag.pointerId);
    if (!touch) return;

    const deltaY = touch.clientY - drag.startY;
    if (Math.abs(deltaY) > 4) drag.moved = true;

    setDragMargin(
      Math.max(openH, Math.min(closeH, drag.startMargin + deltaY))
    );
    if (event.cancelable) event.preventDefault();
  };
  const handleSheetTouchEnd = (event) => {
    const drag = dragRef.current;
    if (!drag || drag.inputType !== "touch") return;

    const touch = findTouch(event.changedTouches, drag.pointerId);
    if (!touch) return;
    finishSheetDragAt(touch.clientY - drag.startY);
  };
  const cancelSheetDrag = () => {
    setDragMargin(null);
    dragRef.current = null;
    suppressClickRef.current = false;
  };
  const activeStep = Math.max(
    1,
    Math.min(6, Math.floor(Number(props.tip)) || 1)
  );
  const [, setCalcType] = useState(
    localStorage.getItem("calc_type") === "true"
  );
  const nextBtn = () => {
    if (props.funcNext) {
      return (
        <>
          {props.slider && (
            <div style={{ marginTop: "-6px" }}>
              <div style={{ color: "white" }}>{t("Calculation type")}</div>
              <div className="slider_wrap">
                <span
                  className="slider_text"
                  style={{
                    fontSize: "14px",
                    marginLeft: "12px",
                    marginTop: "6px",
                  }}
                >
                  {1}
                </span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={
                      localStorage.getItem("calc_type") === "true"
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      setCalcType(e.target.checked);
                      localStorage.setItem("calc_type", e.target.checked);
                    }}
                  />
                  <span className="slider_check round"></span>
                </label>
                <span
                  className="slider_text"
                  style={{
                    fontSize: "14px",
                    marginLeft: "2px",
                    marginRight: "6px",
                    marginTop: "6px",
                  }}
                >
                  {2}
                </span>
              </div>
            </div>
          )}
          <button
            onClick={props.funcNext}
            className="next_btn"
            aria-label={t("Next")}
            style={{
              display: "flex",
              justifyContent: "space-around",
              margin: "10px",
            }}
          >
            <RoundedChevron direction="right" />
          </button>
        </>
      );
    } else {
      if (props.next) {
        return (
          <>
            <Link to={`${props.next}`}>
              <button
                className="next_btn"
                aria-label={t("Next")}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  margin: "10px",
                }}
              >
                <RoundedChevron direction="right" />
              </button>
            </Link>
          </>
        );
      } else {
        return "";
      }
    }
  };

  const prevBtn = () => {
    if (props.funcPrev) {
      return (
        <button
          onClick={props.funcPrev}
          className="prev_btn"
          aria-label={t("Prev")}
          style={{
            display: "flex",
            justifyContent: "space-around",
            margin: "10px",
          }}
        >
          <RoundedChevron direction="left" />
        </button>
      );
    } else {
      if (props.prev) {
        return (
          <Link to={`${props.prev}`}>
              <button
                className="prev_btn"
                aria-label={t("Prev")}
              style={{
                display: "flex",
                justifyContent: "space-around",
                margin: "10px",
              }}
              >
                <RoundedChevron direction="left" />
              </button>
          </Link>
        );
      } else {
        return "";
      }
    }
  };

  return (
    <>
      {props.area ? (
        <div className="areaLabel">
          <span
            style={{
              display: "inline-block",
              width: "150px",
              marginRight: "10px",
            }}
          >
            <span>
              {props.area} m<sup>2</sup>
            </span>
          </span>

          {false && props.heat_area !== undefined && (
            <span>
              <span
                className="ht_label1"
                style={{ display: "inline-block", width: "150px" }}
              >
                <span className="ht_label2">
                  {props.heatAreaLoad === 0 ? props.heat_area : "..."} m
                  <sup>2</sup>
                </span>{" "}
                {props.heatAreaLoad === 1 && (
                  <button
                    className="refreshBtn"
                    onClick={() => {
                      props.refreshArea();
                    }}
                  >
                    <ReactSVG
                      style={{
                        width: "32px",
                        height: "26px",
                      }}
                      src={`${refresh}`}
                    />
                  </button>
                )}
                <span className="ht_label1" style={{ display: "block" }}>
                  {t("Heated area")}
                </span>
              </span>
            </span>
          )}
        </div>
      ) : (
        ""
      )}
      <div
        className={`tip-box-shell ${
          activeMargin <= (openH + closeH) / 2
            ? "tip-box-shell--open"
            : "tip-box-shell--closed"
        }${dragMargin === null ? "" : " tip-box-shell--dragging"}`}
        style={{
          "--tip-box-drag-height": `${dragPanelHeight}px`,
          width: "70vw",
          minWidth: "320px",
          maxWidth: "1080px",
          height: 0,
          position: "fixed",
          zIndex: 50,
          bottom: 0,
          left: "140px",
          right: 0,
          top: "100%",
          margin: "auto",
          marginTop: activeMargin + "px",
          transition:
            dragMargin === null ? "margin-top 300ms ease" : "none",
        }}
      >
        <div
          className={`tip-box-actions ${
            props.prev || props.funcPrev ? "" : "tip-box-actions--single"
          }`}
          style={{
            display: "flex",
            justifyContent:
              props.prev || props.funcPrev ? "space-between" : "right",
            height: "0",
          }}
        >
          {prevBtn()}

          <div
            className="dragDelBlock"
            style={props.spotDel ? { height: "60px" } : { display: "none" }}
            onMouseEnter={(e) => {
              props.spotDel(e.pageX, e.pageY);
            }}
          >
            <ReactSVG src={`${del}`} />
            <span>{t("Drag here")}</span>
          </div>

          {nextBtn()}
        </div>

        <div
          className="tip-box-panel"
          style={{
            marginTop: "80px",
            background:
              "linear-gradient(135.75deg, rgb(163 163 163 / 52%) -1.35%, rgba(30, 36, 62, 0.1) 100%)",
            color: "white",
            border: "1px solid orange",
            borderRadius: "20px",
            height: "320px",
            padding: "10px",
          }}
        >
          <button
            type="button"
            className="tip-box-toggle"
            aria-label={
              activeMargin > (openH + closeH) / 2
                ? t("Open step guidance")
                : t("Close step guidance")
            }
            aria-expanded={activeMargin <= (openH + closeH) / 2}
            style={{
              cursor: "pointer",
              position: "absolute",
              bottom: 0,
              top: "65px",
              left: "25px",
              right: 0,
              fontSize: "12px",
              width: "45px",
              height: "14px",
              backgroundColor: "#646464",
              color: "orange",
              border: "1px solid orange",
              borderRadius: "15px 15px 0 0",
            }}
            onPointerDown={handleSheetPointerDown}
            onPointerMove={handleSheetPointerMove}
            onPointerUp={finishSheetDrag}
            onPointerCancel={cancelSheetDrag}
            onTouchStart={handleSheetTouchStart}
            onTouchMove={handleSheetTouchMove}
            onTouchEnd={handleSheetTouchEnd}
            onTouchCancel={cancelSheetDrag}
            onClick={() => {
              if (suppressClickRef.current) {
                suppressClickRef.current = false;
                return;
              }
              toggleSheet();
            }}
          >
            <span
              className="tip-box-toggle__icon"
              aria-hidden="true"
            />
          </button>
          <div className="tip-box-content" style={{ textAlign: "left" }}>
            <button
              type="button"
              className="tip-box-heading"
              aria-label={`${t("Step")} ${props.tip} ${t("from")} 6`}
              onClick={toggleSheet}
            >
              <span className="tip-box-progress-dots" aria-hidden="true">
                {Array.from({ length: 6 }, (_, index) => (
                  <span
                    key={index}
                    className={`tip-box-progress-dot ${
                      index + 1 === activeStep ? "is-active" : ""
                    }`}
                  />
                ))}
              </span>
              <span className="tip-box-step-status">
                <img alt="" src="img/info.svg" />
                <span>
                  {props.tip} {t("from")} 6
                </span>
              </span>
            </button>
            <div className="tip-box-guidance-card">
              <img
                className="tip-box-guidance-icon"
                alt=""
                src="img/info.svg"
              />
              <p
                className={`tip-box-copy tip-box-copy--step-${String(
                  props.tip
                ).replace(".", "-")}`}
              >
                {t(
                  mobileViewport && String(props.tip) === "2.2"
                    ? "tip_2.2_mobile"
                    : "tip_" + props.tip
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TipBox;
